import { AppTeamUtil } from '../../core/app-team-util';

export class PhotoUploadReportDailyInfo
{
	Date!: Date;
	ActionCount!: number;

	constructor(json?: any)
	{
		this.Date = AppTeamUtil.convertApiDateStringToDate(json['Date'])!;
		this.ActionCount = json.ActionCount;
	}
}

export class PhotoUploadReportData
{
	ActivePhotoCount!: number;
	DailyInfo!: PhotoUploadReportDailyInfo[];
	TotalPhotoCount!: number;

	constructor(json?: any)
	{
		this.ActivePhotoCount = json.ActivePhotoCount;
		this.TotalPhotoCount = json.TotalPhotoCount;
		this.DailyInfo = json.DailyInfo.map((itemJson: any) => new PhotoUploadReportDailyInfo(itemJson));
	}
}
